import { render, staticRenderFns } from "./ListProductRequire.vue?vue&type=template&id=206de879&"
import script from "./ListProductRequire.vue?vue&type=script&lang=js&"
export * from "./ListProductRequire.vue?vue&type=script&lang=js&"
import style0 from "./ListProductRequire.vue?vue&type=style&index=0&id=206de879&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports